<template>
  <div class="pb-3" >
    <va-card :title="$t(`raffles.cards.create`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo do Sorteio" v-slot="{ errors }">
                <va-input
                  v-model="raffle.name"
                  class="mt-2"
                  :label="$t('raffles.forms.nameLabel')"
                  :placeholder="$t('raffles.forms.namePlaceholder')"
                  :success="errors.length == 0 && raffle.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Autorização" v-slot="{ errors }">
                <va-input
                  v-model="raffle.authorization"
                  class="mt-2"
                  :label="$t('raffles.forms.authorizationLabel')"
                  :placeholder="$t('raffles.forms.authorizationPlaceholder')"
                  :success="errors.length == 0 && raffle.authorization.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Data e Hora do Sorteio" v-slot="{ errors }">
                <va-date-picker
                  :label="$t('raffles.forms.datetimeLabel')"
                  :placeholder="$t('raffles.forms.datetimePlaceholder')"
                  :config="{enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true}"
                  :success="errors.length == 0 && raffle.datetime.length > 0"
                  :error="errors.length > 0"
                  :messages="errors"
                  v-model="raffle.datetime"
                />
              </ValidationProvider>
              <ValidationProvider name="Imagem" :rules="'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('raffles.prizes.forms.imageLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="image"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  :to="{ name: 'raffles'}">
                  {{ $t("forms.back") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import '../posts/ckeditor.css'
import gql from 'graphql-tag'
import ErrorMessages from '../utils/ErrorMessages'
export default {
  name: 'RafflesAdd',
  components: {
    ErrorMessages,
  },
  data () {
    return {
      raffle: {
        name: '',
        authorization: '',
        datetime: '',
        image: '',
      },
      image: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.raffle.name = ''
    this.raffle.authorization = ''
    this.raffle.datetime = ''
    this.raffle.image = ''
  },
  watch: {
    image (value) {
      if (value.length > 0) {
        this.raffle.image = value[0].name
      }
    },
  },
  methods: {
    upload () {
      if (this.raffle.image.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.image[0])
        formData.append('path', 'raffles')
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.raffle.image = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.raffle.image = ''
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, authorization, datetime, image } = this.raffle
      const self = this
      this.$apollo
        .mutate({
          mutation: gql`
                mutation MyMutation($name: String, $authorization: String, $image: String, $datetime: timestamp) {
                  insert_raffle(objects: {name: $name, authorization_number: $authorization, image: $image, datetime: $datetime}) {
                    affected_rows
                  }
                }
                `,
          variables: {
            name,
            authorization,
            datetime,
            image,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.showToast(
            self.$t('toasts.successCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
              onComplete: () => self.$router.push({ name: 'raffles' }),
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.showToast(
            self.$t('toasts.errorCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
